import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Create a single place
 *
 * @private
 */
export const createPlace = createAsyncThunk<
  // Return type of the payload creator
  string,
  // First argument to the payload creator
  uui.domain.client.gps.wwgps.Place,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/place/create', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/place/create', {
      category: 'rpc',
      type: 'rpc/place/create',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {createPlace}`,
      { tags: ['rpc', 'place'], info: payload },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Create place failed`,
      error,
    })
  }
})
